import { FormikProvider } from "formik";
import ButtonWithLoader from "../../../../../../../common/components/ui/loading/ButtonLoading";
import SlideToggle from "../../../../../../../common/components/ui/toggleSwitch/SlideToggle";
import { IRenter } from "../../../../../../../types/renter.type";
import DynamicFields from "./field/DynamicFields";
import RegisterPhotos from "./field/RegisterPhotos";
import { CancellationDetails } from "./field/CancellationDetails";
import AditionalValuesCancelPlan from "./field/AdditionalValuesCancelPlan";
import PaymentDetails from "./field/PaymentDetails";
import { useCancelPlan } from "./customHook/useCancelPlan";

type Props = {
  data: IRenter;
  vehicleId: string;
  daysRemaining: number;
  repossessionDate: Date;
};

export default function CancelPlanModal(props: Props) {
  const { data: renter, vehicleId, repossessionDate } = props;

  // 👇 Toda a lógica agora vem do hook
  const {
    formik,
    isChecked,
    caucao,
    valueWeeks,
    dailyValue,
    finePlanValue,
    paymentOptions,
    cancellationReasonOptions,
    installmentOptions,
    registers,
    nameRenter,
    onAddRegister,
    handleTotalChange,
    handleTrafficFinesToggle,
  } = useCancelPlan({
    renter,
    vehicleId,
    daysRemaining: props.daysRemaining,
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <FormikProvider value={formik}>
        <section>
          <CancellationDetails
            finePlanValue={finePlanValue}
            repossessionDate={repossessionDate}
            cancellationReasonOptions={cancellationReasonOptions}
          />
        </section>

        <section>
          <AditionalValuesCancelPlan
            onTotalChange={handleTotalChange}
            valueWeeks={valueWeeks}
            dailyFine={dailyValue}
            finePlanValue={finePlanValue}
          />
        </section>

        <div className="pb-3 mt-2 flex items-center">
          <label className="font-semibold text-[14px]">
            O cliente tem multas de trânsito?
          </label>
          <SlideToggle
            name="isChecked"
            className="ml-2"
            onToggle={handleTrafficFinesToggle}
          />
          <span className="ml-2">{isChecked ? "Sim" : "Não"}</span>
        </div>

        {isChecked && (
          <div>
            <DynamicFields />
          </div>
        )}

        <div className="flex flex-col gap-2">
          <label
            htmlFor="additionalComments"
            className="block text-sm font-medium text-gray-600"
          >
            Descreva o motivo do cancelamento:
          </label>
          <textarea
            id="additionalComments"
            name="additionalComments"
            value={formik.values.additionalComments}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            style={{ resize: "none", height: "90px" }}
            className="border rounded p-2"
          />
          {formik.touched.additionalComments && formik.errors.additionalComments && (
            <div className="text-redPrimary text-sm">
              {formik.errors.additionalComments}
            </div>
          )}
        </div>

        <section>
          <PaymentDetails
            caucao={caucao}
            valueTotal={formik.values.finalFineValue}
            paymentOptions={paymentOptions}
            installmentOptions={installmentOptions}
            amountValue={formik.values.amountValue}
            modal={"CancelPlanModal"}
          />
        </section>
      </FormikProvider>

      <RegisterPhotos
        title={"Inspeção de Veículo"}
        items={registers}
        vehicleId={vehicleId}
        renterId={renter._id!}
        nameRenter={nameRenter}
        onAddItem={onAddRegister}
        updateStatus={undefined}
        titleTextArea={"Descreva as avarias da moto:"}
      />

      <div className="flex justify-end mt-4">
        <ButtonWithLoader
          type="button"
          isLoading={formik.isSubmitting}
          disabled={!formik.isValid}
          onClick={formik.handleSubmit}
        >
          Finalizar Plano
        </ButtonWithLoader>
      </div>
    </form>
  );
}